import { type JSX, Show } from 'solid-js';
import { SESSION_TOKEN, useSessionMe } from '../lib/session';
import { NotificationInboxBell } from './NotificationInboxBell';

// The topbar bell's gate. The inbox is PERSONAL: `GET /v1/notifications` refuses
// a user-less bearer (a seeded dev PAT, a machine token) with 403 "notifications
// are personal", and this bell sits on every page, so it asked and was refused on
// every page. It now mounts the inbox bell — its read AND its `notifications`
// stream topic — only once the session's `/v1/me` names a person, and nothing
// while that read is unsettled (the `LinkCandidatesBanner` rule). A credential
// with no person has no inbox, so it gets no bell.

export function NotificationBell(props: {
  token?: string | null;
  /** The tone for an arrival (#5890); the stored choice by default. A test passes a counter. */
  playSound?: () => Promise<boolean>;
}): JSX.Element {
  const token = props.token === undefined ? SESSION_TOKEN : props.token;
  const me = useSessionMe(token);
  return (
    <Show when={me.data?.user != null}>
      <NotificationInboxBell token={token} playSound={props.playSound} />
    </Show>
  );
}
